export const BsMenu = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5.5C2 4.67157 2.67157 4 3.5 4H20.5C21.3284 4 22 4.67157 22 5.5C22 6.32843 21.3284 7 20.5 7H3.5C2.67157 7 2 6.32843 2 5.5ZM7 12.5C7 11.6716 7.67157 11 8.5 11H20.5C21.3284 11 22 11.6716 22 12.5C22 13.3284 21.3284 14 20.5 14H8.5C7.67157 14 7 13.3284 7 12.5ZM5.5 18C4.67157 18 4 18.6716 4 19.5C4 20.3284 4.67157 21 5.5 21H20.5C21.3284 21 22 20.3284 22 19.5C22 18.6716 21.3284 18 20.5 18H5.5Z"
        fill="current-color"
      />
    </svg>
  );
};

export const BsVideo = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 13.4019L19 16L14.5 18.5981V13.4019Z"
        fill="current-color"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31ZM13.5 11.6699L21 16L13.5 20.3301V11.6699Z"
        fill="current-color"
      />
    </svg>
  );
};
